__turbopack_context__.v({
  "postCard": "RelatedPostCard-module__AcPEqW__postCard",
  "postOverlay": "RelatedPostCard-module__AcPEqW__postOverlay",
  "postTitle": "RelatedPostCard-module__AcPEqW__postTitle",
});
